import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({ selector: '[soloip]' })
export class SoloDireccionesIpDirective {

  constructor(private readonly elRef: ElementRef) { }
  @HostListener('keydown', ['$event'])
  onKeyDown(event :Event): void {
    const soloip = /[^\d+(\.\d+)*$]*/g
    const initValue = this.elRef.nativeElement.value;
    this.elRef.nativeElement.value = initValue.replace(soloip, '')
    if (initValue !== this.elRef.nativeElement.value){
      event.stopImmediatePropagation();
    }
  }
  @HostListener('keyup', ['$event'])
  oKeyUp(event :Event): void {
    const soloip = /[^\d+(\.\d+)*$]*/g
    const initValue = this.elRef.nativeElement.value;
    this.elRef.nativeElement.value = initValue.replace(soloip, '')
    if (initValue !== this.elRef.nativeElement.value){
      event.stopImmediatePropagation();
    }
  }
}
